// BHK-based pricing for the "Host Pro" plan, matching the pricing sheet (same table used by
// the admin ManageHostPlans dashboard's price preview and PremiumPlanPricing.java on the
// backend — server-side computes/stores the authoritative price when an admin assigns a plan;
// this copy is presentational only, for showing a live price on this public page).
export const BHK_OPTIONS = [1, 2, 3, 4, 5, 6, 7, 8];

export const PRICE_TABLE = {
  1: { three: 2674, six: 4650, twelve: 9300 },
  2: { three: 5348, six: 9300, twelve: 18600 },
  3: { three: 8021, six: 13950, twelve: 27900 },
  4: { three: 10695, six: 18600, twelve: 37200 },
  5: { three: 13369, six: 23250, twelve: 46500 },
  6: { three: 16043, six: 27900, twelve: 55800 },
  7: { three: 18716, six: 32550, twelve: 65100 },
  8: { three: 21390, six: 37200, twelve: 74400 },
};

export const DURATIONS = [
  // `billingCycle` is the exact token the backend expects (PlanBillingCycle enum);
  // `key` is only this page's internal id for PRICE_TABLE / the segmented control.
  { key: 'three', label: '3 Months', months: 3, billingCycle: 'three_month' },
  { key: 'six', label: '6 Months', months: 6, recommended: true, billingCycle: 'six_month' },
  { key: 'twelve', label: '12 Months', months: 12, billingCycle: 'twelve_month' },
];

export const trustStats = [
  { icon: 'properties', value: '3,600+', label: 'Properties Listed' },
  { icon: 'customers', value: '7,500+', label: 'Happy Customers' },
  { icon: 'occupancy', value: '17%', label: 'Avg. Occupancy Increase' },
  { icon: 'rating', value: '4.86/5', label: 'Customer Rating' },
];

// Feature comparison — Starter (free tier) vs Host Pro (the paid plan; internally stored as the "premium"
// plan type, see PlanType.java). `tooltip` text comes straight from the pricing sheet.
// `tooltipOn: 'pro'` places the info icon next to the Host Pro value rather than the label,
// since those tooltips explain the Host Pro benefit specifically.
export const featureComparison = [
  { feature: 'Host Commissions Fee', free: '2%', pro: '0%' },
  {
    feature: 'Customer Commissions Fee',
    free: '8%',
    pro: '2%',
    tooltip:
      'Customer just pays 2% against 15-18% that platforms usually charge, creating easy opportunity for hosts to monetise better',
    tooltipOn: 'pro',
  },
  {
    feature: 'Property Cover',
    free: 'cross',
    pro: 'check',
    tooltip: 'Get damage cover for property',
    tooltipOn: 'pro',
  },
  {
    feature: 'Customer Chats',
    free: 'Restricted',
    pro: 'Unrestricted',
    tooltip: 'Chat with interested customers without restrictions. Share your phone numbers, location etc before bookings',
    tooltipOn: 'pro',
  },
  {
    feature: 'Brand Mini Website',
    free: 'cross',
    pro: 'check',
    tooltip: 'A mini brand website that can be used by hosts even for direct bookings',
  },
  { feature: 'Support', free: 'Email, Chat', pro: 'Dedicated Phone Line' },
  {
    feature: 'Exposure to Travel Agent Network',
    free: 'cross',
    pro: 'check',
    tooltip: 'Exposure to 20,000+ travel agents via our exclusive partnerships',
  },
  {
    feature: 'Analytics',
    free: 'cross',
    pro: 'check',
    tooltip: '(Under development) Get reports to understand traffic and performance of your listings',
  },
  {
    feature: 'Profile Improvement',
    free: 'cross',
    pro: 'check',
    tooltip: 'Image and video enhancement support from Unpaqd to make your listing shine',
  },
  {
    feature: 'Complimentary Integration Support',
    free: 'cross',
    pro: 'check',
    tooltip: 'Connect with channel managers easily via our inhouse tech support',
  },
];

export const faqData = [
  {
    question: 'How does the 0% commission work?',
    answer:
      'On Host Pro, neither you nor your guests pay platform commissions on bookings - you keep 100% of your earnings, and guests pay just 2% instead of the 15-18% other platforms charge.',
  },
  {
    question: 'Can I switch plans at any time?',
    answer:
      "Yes, you can move from Starter to Host Pro whenever you're ready. Your Host Pro period runs for the duration you choose (3, 6, or 12 months) from the day it starts.",
  },
  {
    question: 'What happens when I reach my 2 free bookings?',
    answer:
      'The Starter plan is capped at 2 bookings. Upgrade to Host Pro for unlimited bookings, 0% commission, and unrestricted guest chats.',
  },
  {
    question: 'Is there a setup fee or long-term contract?',
    answer: 'No setup fees. Host Pro is a fixed-term plan (3, 6, or 12 months) with no auto-renewal surprises.',
  },
  {
    question: 'Why does the price vary by BHK?',
    answer:
      'Host Pro pricing scales with your property size (1-8 BHK) since larger properties typically see proportionally higher booking value. Pick your BHK above to see your exact price.',
  },
  {
    question: 'What is the Travel Agent network?',
    answer: 'Host Pro gives your listings exposure to our network of 20,000+ partner travel agents across India.',
  },
];
